module.exports = __webpack_public_path__ + "static/media/206-gallery05.7c7a1209.jpg";